<template>
<div>
    <div
      class="modal"
      v-bind:class="{ active: selectsizemodal === true }"
      id="coupon-modal"
      v-if="selectsizemodal"
    >
      <div class="modal-dialog listStorePopup">
        <div class="modal-content">
          <div class="modal-body">
             <button
              type="button"
              class="close"
              @click="selectsizemodal = false"
              style="
                
                margin-right: 15px;
                z-index: 999;
                
                right: 0px;
                font-size: 25px;
              "
            >
              &times;
            </button>
                <!-- <div class="size">
                    <p>Size - <span v-for="variation in variations"
                          v-text="variation.configrable_atribute_value"></span> </p>
                </div> -->

            <div class="size-container">
              <h3 class="productsHighlight">Select Size </h3>
               <div class="size-bg">
                  <div class="size-box">
                    <label
                      class="size select-one-size select-size"
                      v-for="(items, i) in variations"
                      @click="selectSize(items)"
                      :key="i"
                      v-bind:class="{
                      disabled: items.quantity <= '0',
                      selected:
                      selectedsize == items.configrable_atribute_value
                  }"
                    >
                    {{items.configrable_atribute_value}}
                    </label>
                     <p class="section_error">{{ size_error }}</p>
                  </div>
               </div>
             </div>
                <button
                style="font-size:18px;margin-top:10px;"
                type="button"
                v-ripple
                class="add-to-cart btn"
                id="product-addtocart-button"
                title="Add to cart"
                @click="addsizecart()"
              >
                <img
                  src="img/shoppingCart.png"
                  alt=""
                  style="margin-right: 10px"
                />
                Add to cart
              </button>
          </div>

       
       </div>
      </div>
    </div>



  <div class="container-fluid cart-container section-main-container">
    <div class="row">
      <div class="wishlistSkeleton col-md-12" v-if="wishlistLoader" >
        <PuSkeleton  class=" Skeleton1"  width="100%" height="inherit"  />
        <PuSkeleton  class=" Skeleton2"  width="100%" height="inherit"  />
      </div>
      <div class="col-md-12 product-section-main" v-else>
        <div class="row m-0">
          <div class="col-md-12">
            <h1 class="text-center font-medium cart-title">Wishlist</h1>
          </div>
          <div
            class="col-md-12 product-list"
            v-if="this.wishlistProduct.length"
          >
            <div class="row row-m-30">
              <!-- <div class="col-md-3 col-sm-6 col-xs-6 col-6 products-container"
                                v-for="(article, index) of wishlist" :key="index">
                                <div class="list-product">
                                    <a href="#" @click.prevent="remove_w(article.sku,index)" class="wishlist">×</a>
                                    <p class="new" v-if="article.new_collection=='Yes'">NEW</p>
                                    <p class="new" v-if="article.trending=='Yes'">TREND</p>
                                    <p class="price-per" v-if="article.selling_price != article.price">
                                        {{(100 - (article.selling_price*100)/article.price).toFixed(0)}}%
                                        off</p>
                                    <router-link
                                        :to="{name:'detail', params:{ pro_id: article.id_product, pro_url_key:article.url_key}}"
                                        :key="article.id_category">
                                        <img :src="article.hover_image"
                                            v-if="article.hover_image&&article.hover_image!=''"
                                            class="w-100 hover-image" alt="Product">
                                        <img :src="article.image" v-else class="w-100 hover-image" alt="Product">
                                    </router-link>
                                    <router-link
                                        :to="{name:'detail', params:{ pro_id: article.id_product, pro_url_key:article.url_key}}"
                                        :key="article.id_category">
                                        <img :src="article.image" v-if="article.image!=''" class="w-100 image"
                                            alt="Product">
                                        <img src="/images/product-thumb.png" v-else class="w-100 image" alt="Product">
                                    </router-link>
                                    <router-link
                                        :to="{name:'detail', params:{ pro_id: article.id_product, pro_url_key:article.url_key}}"
                                        :key="article.id_category">
                                        <p class="name">{{article.name}}</p>
                                    </router-link>
                                    <p class="price" v-if="article.selling_price != article.price"><span
                                            class="old-price" v-text="'₹ '+article.price"></span> <span
                                            class="main-price" v-text="'₹ '+article.selling_price"></span>
                                    </p>
                                    <p class="price" v-else><span class="main-price"
                                            v-text="'₹ '+article.selling_price"></span>
                                    </p>
                                    <ul class="color"
                                        v-if="article.variation&&article.color!=null&&article.product_type!='contact_lens'">
                                        <li :class="{active:article.sku==item.sku}"
                                            @click="product_color_change(index,i)" v-for="(item,i) in article.variation"
                                            v-if="i<3">
                                            <div class="color-tooltip" v-if="item.lens_color!=null||item.color!=null">
                                                <p v-if="item.color!=null"><b class="font-bold">Frame Color : </b>
                                                    {{item.color}}</p>
                                                <p v-if="item.lens_color!=null"><b class="font-bold">Lens Color :</b>
                                                    {{item.lens_color}} </p>
                                            </div><span :class="item.color+' '+item.lens_color"></span>
                                        </li>
                                        <router-link v-if="article.variation.length>3" class="more"
                                            :to="{name:'detail', params:{ pro_id: article.id_product, pro_url_key:article.url_key}}"
                                            :key="article.id_category">More</router-link>
                                    </ul>
                                    <ul class="color" v-if="!article.variation&&article.product_type!='contact_lens'">
                                    </ul>
                                </div>
                            </div> -->
              <div class="col-md-12 product-list">
                <div class="row">
                  <div
                    class="col-md-3 col-sm-6 col-xs-6 col-6 pr-0"
                    v-for="(article, index) of wishlistProduct"
                    :key="index"
                  >
                    <div class="slide-box margin">
                      <div class="product-box">
                        <!--div class="offer-tag">New</div-->
                        <!-- <router-link
                                                :to="{name:'detail', params:{ pro_id: article.id_product, pro_url_key:article.url_key,},
                                                query: { store: article.store }
                                                }"
                                                :key="article.id_category" class="view-detail"
                                                @click.native="gtm_product_click(article.name,article.sku,article.selling_price,article.category,index)">
                                                View Detail
                                            </router-link> -->
                        <router-link
                          :to="{
                            name: 'detail',
                            params: {
                              pro_id: article.id_product,
                              pro_url_key: article.url_key,
                            },
                            query: { store: article.store },
                          }"
                          :key="article.id_category"
                          @click.native="
                            gtm_product_click(
                              article.name,
                              article.sku,
                              article.selling_price,
                              article.category,
                              index
                            )
                          "
                        >
                          <!-- <div class="product_image" 
                                                 :style="{ backgroundImage: `url(${article.image})` }"
                                                >
                                                </div> -->

                          <responsive-image
                            :alt="article.name"
                            :title="article.name"
                            v-bind:desktop="`${$root.image_url_c}inside/350x250/${article.image}`"
                            v-bind:tab="`${$root.image_url_c}inside/350x250/${article.image}`"
                            v-bind:mobile="`${$root.image_url_c}inside/350x250/${article.image}`"
                            v-bind:default_image="`${$root.image_url_c}inside/350x250/${article.image}`"
                          />
                          <!-- {{article}} -->
                        </router-link>
                        <span
                          class="removeWishlist"
                          @click="remove_w(article.id_product)"
                          ><i class="fa fa-times" aria-hidden="true"></i
                        ></span>
                      </div>

                      <p>
                        <router-link
                          :to="{
                            name: 'detail',
                            params: {
                              pro_id: article.id_product,
                              pro_url_key: article.url_key,
                            },
                            query: { store: article.store },
                          }"
                          :key="article.id_category"
                          @click.native="
                            gtm_product_click(
                              article.name,
                              article.sku,
                              article.selling_price,
                              article.category,
                              index
                            )
                          "
                          v-text="article.name"
                        ></router-link>
                      </p>
                      <!-- v-if="article.selling_price != article.price" -->
                      <div
                        class="price"
                        v-if="article.selling_price != article.price"
                      >
                        <p>
                          <span class="price">{{
                            article.selling_price | formatMoney
                          }}</span>
                          <span class="old-price">{{
                            article.price | formatMoney
                          }}</span>
                          <span
                            class="discount_percent font-bold"
                            v-if="article.product_type == null"
                            >{{
                              $root.percentOff(
                                article.price,
                                article.selling_price
                              )
                            }}</span
                          >
                        </p>
                      </div>
                      <div class="price" v-else>
                        <p>
                          <span class="price">{{
                            article.selling_price | formatMoney
                          }}</span>
                        </p>
                      </div>
                      <!-- <div class="size" v-if="article.product_type==null">
                                            <p>Size - <span v-for="option in article.variation"
                                                    v-text="option.configrable_atribute_value"></span> </p>
                                        </div> -->
                    </div>
                    
                   
                    <div class="gProductAdd noWeight">
													<button @click="add_to_cart(article,index)">
														ADD
														<span>&#43;</span>
													</button>
										</div>

                        
                   
                  </div>
                </div>
                <!-- <div class="product_loader" v-show="product_loader == true">
									<loading-icon class="loading-icon newLoader" name="ball-clip-rotate-multiple" color="#ba2126" scale="1"></loading-icon>
								</div> -->
              </div>
            </div>
          </div>
          <div class="col-12 text-center emptyCartContainer" v-else>
            <img class="emptyCart" src="/img/emptyCart.png" />
            <br />
            <h3>You have no items in your Wishlist.<br /></h3>
            <div class="cartFixBtn">
              <button class="btn thankuShopping" @click="$router.push('/')">
                Shop Now
              </button>
            </div>
            <!-- <p>
							<router-link
								:to="{ path: '/', name: 'Home' }"
								v-ripple
								:key="0"
								v-if="this.continue_path === '' || this.continue_path === null"
								><span>Click here</span></router-link >
							<router-link
								:to="{ path: this.continue_path }"
								v-ripple
								:key="0"
								v-else
								><span>Click here</span></router-link > to continue shopping.
						</p> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div> 
</template>

<script>
import axios from "axios";
import { bus } from '../main.js';
export default {
  name: "wishlist",
  components: {},
  metaInfo() {
    return {
      title: "Wishlist",
      meta: [
        {
          name: "description",
          content: "Wishlist",
        },
        {
          property: "keywords",
          content: "Wishlist",
        },
      ],
    };
  },
  data() {
    return {
      wishlistLoader:true,
      firstProductIdInVartion:null,
      selectedsize:null,
      sizeSelected:false,
      size_error:"",
      selectsizemodal:false,
      variations:null,
      product_id:null,
      select_size:null,
      pro_id:null,
      name:null,
      sku:null,
      price:null,
      qty:null,
      selling_price:null,
      goupId:null,
      isGrocery:null,
      wishlist: [],
      wishlistProduct: [],
      continue_path: "",
    };
  },
  beforeMount() {
    this.get_wish();
  },
  methods: {
    selectSize(varitionitem){
        this.selectedsize=varitionitem.configrable_atribute_value
        this.size_error=''
        this.product_id=varitionitem.id_product
        this.pro_id=varitionitem.parent_id
        this.select_size=varitionitem.configrable_atribute_value
        this.name=varitionitem.name
        this.sku=varitionitem.sku
        this.master_sku=varitionitem.sku
        this.price=varitionitem.price
        this.qty=1
        this.selling_price=varitionitem.selling_price
        this.goupId=varitionitem.group_id
        this.isGrocery=varitionitem.is_grocery ? 1 : 0;
        this.store=varitionitem.store
        this.sizeSelected=true
    },
     addsizecart(){

       if(this.sizeSelected==true){
          this.selectsizemodal=false
          this.add_product_to_cart();
          this.remove_from_wishlist(this.firstProductIdInVartion)
       }
       else{
       this.size_error="Please Select Size First"
       }

     },
    add_to_cart: function (product,i) {
      
      if(Object.keys(product.all_sizes)[0]!='' && Object.keys(product.all_sizes)[1]!=undefined){
       this.firstProductIdInVartion=product.id_product
       this.selectsizemodal=true;
       this.variations=product.variation
      }
      else{
        this.product_id=product.id_product
        this.pro_id=product.parent_id
        this.select_size=Object.keys(product.all_sizes)[0]
        this.name=product.name
        this.sku=product.sku
        this.master_sku=product.sku
        this.price=product.price
        this.qty=1
        this.selling_price=product.selling_price
        this.stores
        this.goupId=product.group_id
        this.isGrocery=product.is_grocery ? 1 : 0;
        this.store=product.store
       
       this.add_product_to_cart();
       this.remove_from_wishlist(product.id_product)
      }
    },

    groupByKey(array, key) {
      return array.reduce((hash, obj) => {
        if (obj[key] === undefined) return hash;
        return Object.assign(hash, {
          [obj[key]]: (hash[obj[key]] || []).concat(obj),
        });
      }, {});
    },
    add_product_to_cart(){
      this.$root.pcart = $cookies.get(
        window.location.hostname.substring(10, 4) + "_cart"
      );

        this.$root.page_loader = true;
        var form = new FormData();
        form.append("product_id",this.product_id);
        form.append("product_parent_id", this.pro_id);
        form.append("product_options", this.select_size);
        form.append("name", this.name);
        form.append("sku",this.sku);
        form.append("master_sku", this.master_sku);
        form.append("price", this.price);
        form.append("qty_ordered", this.qty);
        form.append("final_price", this.selling_price);
        form.append("s", [this.stores]);
        form.append("gi", this.goupId);
        form.append("ig", this.isGrocery);
       
        form.append("store", this.store);
        
        // form.append("store", this.$route.query.store);
        form.append("latitude", this.$root.location.lat);
        form.append("longitude", this.$root.location.long);
        // form.append('pcart',0)

        if (this.$root.customer_id) {
          form.append("customer_id", this.$root.customer_id);
        }
        if (this.$root.customer_session) {
          form.append("customer_session", this.$root.customer_session);
        }
        if (this.$root.cart_product.length == 0 && !this.$root.pcart) {
          form.append("pcart", 0);
        } else {
          form.append("pcart", this.$root.pcart);
        }

        let config = { headers: { "Content-Type": "multipart/form-data" } };
        axios
          .post(this.$root.cart_api + "/product/add-product", form, config)
          .then((response) => {
            if (response.data.success === true) {
             
                if (this.$root.numberOfStores < response.data.data.length) {
               
                // this.$toast.success("You have added an item from a different store. Shipping charges may vary accordingly.", {
                //   position: "top",
                //   duration: 1000*300,
                // });
                // this.$toast.success("Product added to cart", {
                //   position: "top",
                //   duration: 4000,
                // });
                bus.$emit('buyingfromotherstores', 'You have added an item from a different store. Shipping charges may vary accordingly');
                // this.$toast.success("Product added to cart", {
                //   position: "top",
                //   duration: 4000,
                //   dismissable : false
                // });
                // this.toastMessage = true;
                
              } else {
                this.$toast.success("Product added to cart", {
                  position: "top",
                  duration: 4000,
                });
              }
             
              this.qty = 1;
              this.$root.error_message = "";
              this.$root.page_loader = false;
              this.$root.cart_total = response.data.data.grand_total;
              this.$root.cart_subtotal = response.data.data.order_subtotal;
              this.$root.discount_code = response.data.data.discount_code;
              this.$root.discount_amount = response.data.data.discount_amount;
              this.$root.address = response.data.data.address;
              if (
                !this.$root.pcart &&
                this.$root.pcart != response.data.data.pcart
              ) {
                this.$root.pcart = response.data.data.pcart;
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  response.data.data.pcart,
                  "1y"
                );
              } else {
                this.$root.pcart = response.data.pcart;
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  response.data.pcart,
                  "1y"
                );
              }

              if (response.data.data.length > 0) {
                this.$root.numberOfStores = response.data.data.length;

                //Products Array
                let ProductsArray = [];
                // Sorting Products array according to SKU
                this.$root.cart_total = 0;
                this.$root.cart_subtotal = 0;
                this.$root.cart_netAmount = 0;
                response.data.data.forEach((products) => {
                  this.$root.cart_total =
                    this.$root.cart_total + products.grand_total;
                  this.$root.cart_subtotal =
                    this.$root.cart_subtotal + products.order_subtotal;
                  this.$root.cart_netAmount =
                    this.$root.cart_netAmount + products.net_amount;

                  let sortedProducts = this.groupByKey(
                    products.products,
                    "sku"
                  );
                   
                  // Creating Sorted Products Array
                  Object.keys(sortedProducts).map(function (key, index) {
                    ProductsArray.push(sortedProducts[key]);
                  });
                });

                // Modifying Price and Quantity accroding to SKU
                let data = [];
                let price = 0;
                ProductsArray.forEach((ele, index) => {
                  let qty = 0;
                  ele.forEach((product) => {
                    qty = qty + product.qty;
                    ele[0]["qty"] = qty;
                  });
                  data.push(ele[0]);
                });
            
                this.$root.cart_product = data;
      
            
              } else {
                // console.log("called else");
                this.$root.numberOfStores = response.data.data.length;
                this.$root.pcart = response.data.data.pcart;
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  response.data.data.pcart,
                  "1y"
                );

                (this.$root.cart_total = response.data.data.grand_total),
                  // net_amount:response.data.data.net_amount,
                  (this.$root.cart_subtotal =
                    response.data.data.order_subtotal);
                // products = response.data.data.products
                // this.$store.dispatch('getAmount', amount)

                this.$root.cart_product = response.data.data.products;
                //  this.$store.dispatch('getCart', response.data.data.products)
              }

              // this.$root.minicart = false;

              // this.$root.pcart = response
              // if (this.$root.address.length != 0) {
              //     for (let i = 0; i < this.$root.address.length; i++) {
              //         if (i == 0) {
              //             this.$root.address_id = this.$root.address[i].id * 1;
              //             this.$root.select_address_no = i;
              //         }
              //     }
              // }

              // this.$root.pcart = response.data.data.pcart;
              this.$root.thankyou_cart = response.data.data.pcart;
              if (response.data.data.cart_session) {
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_carts",
                  response.data.data.cart_session,
                  "1y"
                );
                this.$root.cart_session = response.data.data.cart_session;
              }
              // if (event.target.title === "Buy now") {
              //     this.$gtm.trackEvent({
              //         event: 'addToCart',
              //         category: 'Ecommerce',
              //         action: 'Buy_now',
              //         label: this.name,
              //         ecommerce: {
              //             currencyCode: 'INR',
              //             add: {
              //                 product: [{
              //                     name: this.name,
              //                     id: this.master_sku,
              //                     price: this.selling_price,
              //                     variant: this.size.select_size,
              //                     quantity: this.qty,
              //                     category: this.product_cat,
              //                 }
              //                 ]
              //             }
              //         }
              //     });
              //     setTimeout(() => this.$gtm.trackEvent({

              //         event: 'checkout',
              //         category: 'Ecommerce',
              //         action: 'Buy_now',
              //         label: '1',
              //         ecommerce: {
              //             checkout: {
              //                 'actionField': { 'step': 1, 'option': this.$root.login_status },
              //                 product: this.$root.gtm_product,
              //             }
              //         }
              //     }), 100);

              //     this.$router.push('checkout.html');
              // }
              // else {
              //     this.$root.minicart = false;
              //     this.size_active = true;
              //     this.$gtm.trackEvent({
              //         event: 'addToCart',
              //         category: 'Ecommerce',
              //         action: 'Add_to_cart',
              //         label: this.name,
              //         ecommerce: {
              //             currencyCode: 'INR',
              //             add: {
              //                 product: [{
              //                     name: this.name,
              //                     id: this.master_sku,
              //                     price: this.selling_price,
              //                     variant: this.size.select_size,
              //                     quantity: this.qty,
              //                     category: this.product_cat,
              //                 }
              //                 ]
              //             }
              //         }
              //     });
              // }

           
            } else {
              this.$root.success_message = "";
              this.$toast.error(response.data.message, {
                position: "top-right",
                duration: 4000,
              });
              // this.$root.error_message = response.data.message;
              this.$root.page_loader = false;

              $cookies.set(
                window.location.hostname.substring(10, 4) + "_cart",
                "",
                "1y"
              );
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_carts",
                "",
                "1y"
              );
              // this.$root.pcart = "";
              // this.$root.cart_session = "";
              // this.$root.cart_product = [];
            }
          })
          .catch((error) => {
            console.log("error response new", error.response);
            // this.$root.pcart = "";
            // this.$root.cart_session = "";
            // this.$root.cart_product = [];
            console.log(error);
            this.$root.page_loader = false;
            // this.$root.error_message = error.message;
            window.scrollTo(0, 0);
          });
      
    },
    remove_w(id) {
      
      this.$root.page_loader = true;
      var form = new FormData();
      form.append("customer_id", this.$root.customer_id);
      form.append("customer_session", this.$root.customer_session);
      form.append("product_id", id);
      form.append("type", "remove");
      axios
        .post(this.$root.cart_api + `/wishlist/remove-product`, form)
        .then((response) => {
          if (response.data.success == true) {
            this.$root.page_loader = false;
            this.$root.wishListProducts = this.$root.wishListProducts - 1;
            this.wishlistProduct = this.wishlistProduct.filter(
              (pro) => pro.id_product != id
            );
            this.$toast.success(response.data.message, {
              position: "top",
              duration: 4000,
            });
          } else {
            this.$root.page_loader = false;
            if (response.data.data.customer_session_status == false) {
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_customer",
                "",
                "1y"
              );
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_cus_sess",
                "",
                "1y"
              );
              this.$root.customer_id = "";
              this.$root.customer_session = "";
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_cart",
                "",
                "1y"
              );
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_ct_sess",
                "",
                "1y"
              );
              this.$root.cart_id = "";
              this.$root.cart_session = "";
              this.$root.cart_product = [];
            }
          }
        });
    },
    remove_from_wishlist(id) {
      
      this.$root.page_loader = true;
      var form = new FormData();
      form.append("customer_id", this.$root.customer_id);
      form.append("customer_session", this.$root.customer_session);
      form.append("product_id", id);
      form.append("type", "remove");
      axios
        .post(this.$root.cart_api + `/wishlist/remove-product`, form)
        .then((response) => {
          if (response.data.success == true) {
            this.$root.page_loader = false;
            this.$root.wishListProducts = this.$root.wishListProducts - 1;
            this.wishlistProduct = this.wishlistProduct.filter(
              (pro) => pro.id_product != id
            );
           
          } else {
            this.$root.page_loader = false;
            if (response.data.data.customer_session_status == false) {
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_customer",
                "",
                "1y"
              );
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_cus_sess",
                "",
                "1y"
              );
              this.$root.customer_id = "";
              this.$root.customer_session = "";
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_cart",
                "",
                "1y"
              );
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_ct_sess",
                "",
                "1y"
              );
              this.$root.cart_id = "";
              this.$root.cart_session = "";
              this.$root.cart_product = [];
            }
          }
        });
    },
    get_wish() {
      this.$root.breadcrumb = "";
      this.$root.page_loader = true;
      var form = new FormData();
      form.append("customer_id", this.$root.customer_id);
      form.append("customer_session", this.$root.customer_session);
      form.append("type", "get");
      axios
        .post(this.$root.cart_api + `/wishlist/items`, form)
        .then((response) => {
          // console.log(response);
          if (response.data.success == true) {
            if (response.data.data == 0) {
              this.$root.wishListProducts = 0;
            }
            this.wishlistProduct = response.data.data;
            this.$root.page_loader = false;
            // this.$root.wishlistProduct = response.data.data.length;
            // if (this.wishlist.length) {
            //     axios.get(this.$root.api_url + `/pim/pimresponse.php?service=wishlist&sku=${this.wishlist}&store=1`)
            //     .then(response => {
            //         this.$root.page_loader = false;
            //         this.wishlistProduct = response.data.result
            //     })
            // }
            // else {
            //     this.$root.page_loader = false;
            // }
          } else {
            this.$root.page_loader = false;
            if (response.data.data.customer_session_status == false) {
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_customer",
                "",
                "1y"
              );
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_cs",
                "",
                "1y"
              );
              this.$root.customer_id = "";
              this.$root.customer_session = "";
            }
          }
          this.wishlistLoader = false;
        });
    },
    created() {
      this.continue_path = $cookies.get(
        window.location.hostname.substring(10, 4) + "_last_list_path"
      );
      window.scrollTo(0, 0);
    },
  },
};
</script>
<style scoped>
  .wishlistSkeleton {
    height: 100vh;
    margin-top:10px ;
  }
  .wishlistSkeleton .Skeleton1 {
    height: 10%;

  }
  .wishlistSkeleton .Skeleton2 {
    height: 80%;
  }
  @media screen and (max-width:767px) {

    .wishlistSkeleton {
    height: 70vh;
  }
  }
</style>